import React, {Component} from 'react';
import MathJax from 'react-mathjax2'

class LatexViewComponent3 extends Component {
    constructor(props){
        super(props)

        this.state = {

        }
    }

    componentDidMount(){
        this.setState({
            text: this.props.text
        })
    }

    /*shouldComponentUpdate(nextProps, nextState){
        if(this.state.text != nextProps.text){
            console.log('updating')
            return true
        }

        return false
    }*/

    render(){
        return(
            <div  style = {{width:'100%', height: 50,
                            flexDirection:'column', display: 'flex', alignItems:'center', justifyContent:'center' }}>
                        <MathJax.Context
                                input='tex'
                                onLoad = {() => console.log("loaded: " +this.props.latex_formula)}
                                onError={ (MathJax, error) => {
                                    console.warn(error);
                                    console.log("Encountered a MathJax error, re-attempting a typeset!");
                                    MathJax.Hub.Queue(
                                        MathJax.Hub.Typeset()
                                    );
                                } }
                                script="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=AM_HTMLorMML"
                                
                            >
                                <MathJax.Node inline>{ this.props.latex_formula }</MathJax.Node>
                            </MathJax.Context>
                    </div>
        )
    }
}

export default LatexViewComponent3